const defaultLocale = 'it-IT';

/**
 * Formatta un importo in valuta. Nasce per l'importo del preventivo (TS-87), il
 * primo campo monetario che il CRM mostra all'utente.
 *
 * La valuta è fissa a EUR e non è un parametro: il modello backend non porta un
 * codice valuta — `amount` è un `double` e basta — quindi accettarlo qui
 * darebbe l'illusione di un multi-valuta che non esiste. Il giorno in cui il
 * backend avrà la valuta, questa firma cambia insieme al modello.
 */
export function formatCurrency(value: number, locale = defaultLocale): string {
  return value.toLocaleString(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
